import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { colors } from 'components/styles/variables';
import TrackingDataContext from 'contexts/TrackingDataContext';
import { trackDealerPagesClick } from 'lib/Tracking/DealerPages';
import { DealerPagesEventType } from 'lib/EventSchema';

function trackViewListingsClick(dealerPageUrl) {
  trackDealerPagesClick({
    type: DealerPagesEventType.view_listings_button_click,
    dealerPageUrl,
  });
}

function trackReadReviewsClick(dealerPageUrl) {
  trackDealerPagesClick({
    type: DealerPagesEventType.read_reviews_button_click,
    dealerPageUrl,
  });
}

export default function CTAButtons() {
  const { dealerPageUrl } = useContext(TrackingDataContext);
  const { t } = useTranslation();
  return (
    <div className="buttons">
      <a
        href="#listings"
        className="button"
        data-testid="listings"
        onClick={() => trackViewListingsClick(dealerPageUrl)}
      >
        {t('dealerPages.viewListings')}
      </a>
      <a
        href="#reviews"
        className="button"
        data-testid="reviews"
        onClick={() => trackReadReviewsClick(dealerPageUrl)}
      >
        {t('dealerPages.readReviews')}
      </a>
      <style jsx>
        {`
          .buttons {
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
            margin-top: 10px;
          }

          .button {
            background-color: ${colors.ALR1};
            border-radius: 8px;
            font-weight: 900;
            font-size: 16px;
            color: white;
            height: 45px;
            flex-grow: 1;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .button:hover {
            background-color: ${colors.ALR2};
            border: solid 2px ${colors.ALR2};
          }

          .button:first-child {
            margin-right: 8px;
          }

          .button:last-child {
            margin-left: 8px;
          }
        `}
      </style>
    </div>
  );
}
